export * from './ort-kategories.service';
export * from './ort-kategories.service.module';